import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { QUERY_PROGRESS_PENDING, TRACK_EVENTS } from "core/consts";
import { FileState, QueryProgress } from "core/types";
import RSButton from "ds_legacy/components/RSButton";
import { getFileSource } from "dsl/ecosystems/PatientFiles/utils";
import { useTracking } from "react-tracking";
import { useTranslations } from "translations";
import { useDialogStyles } from "..";

export type FileDeleteModalProps = {
  file?: FileState;
  handleDelete: () => void;
  isOpen?: boolean;
  mutationProgress: QueryProgress;
  reset: () => void;
};

export function FileDeleteModal({
  file,
  handleDelete,
  isOpen,
  mutationProgress,
  reset,
}: FileDeleteModalProps) {
  const classes = useDialogStyles();
  const translations = useTranslations();
  const { trackEvent } = useTracking();

  if (!isOpen) return null;

  return (
    <Dialog
      classes={{ paper: classes.dialog }}
      fullWidth
      maxWidth="sm"
      open={Boolean(isOpen)}
    >
      <DialogTitle>{translations.actions.confirm}</DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <DialogContentText>
          {translations.fileSection.fileDeleteModal.title}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <RSButton
          color="primary"
          disabled={mutationProgress === QUERY_PROGRESS_PENDING}
          id="back"
          loading="na"
          variant="text"
          onClick={() => {
            trackEvent({
              cta: "back",
              file_implementation: "HIS",
              modal: "delete",
              name: TRACK_EVENTS.FILE_MODAL_CTA_CLICKED,
              source: getFileSource(file),
            });
            reset();
          }}
        >
          {translations.actions.back}
        </RSButton>
        <RSButton
          color="primary"
          id="delete"
          inverted
          loading={mutationProgress}
          variant="text"
          onClick={() => {
            trackEvent({
              cta: "delete",
              file_implementation: "HIS",
              modal: "delete",
              name: TRACK_EVENTS.FILE_MODAL_CTA_CLICKED,
              source: getFileSource(file),
            });
            handleDelete();
          }}
        >
          {translations.actions.delete}
        </RSButton>
      </DialogActions>
    </Dialog>
  );
}

export default FileDeleteModal;
